import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { AssemblyOverviewEditAssemblyPage } from '@/areas/assemblies/AssemblyForm/pages/AssemblyOverviewEditAssemblyPage';
import { assembliesEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/assemblies/$assemblyId/edit')({
    staticData: {
        access: { permissions: ['edit:assembly'], modulePermissions: assembliesEditModulePermissions },
        chrome: 'home',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ rfqId: 'required' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const rfqId = Route.useSearch({ select: (search) => search.rfqId });
    return <AssemblyOverviewEditAssemblyPage rfqId={rfqId} assemblyId={pathParams.assemblyId} />;
}
